import { Component, OnInit, ChangeDetectionStrategy, ElementRef, inject, viewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { LangComponent } from '@cue-admin/shared';
import { Align, PopupModule } from '@progress/kendo-angular-popup';
import { TranslateService } from '@ngx-translate/core';
import { CONSTANTS } from '@cue-admin/constants';
import { HelpService } from '@cue-admin/help-data';
import { Router } from '@angular/router';
import { AccountMenuComponent } from '../account-menu/account-menu.component';
import { UpperCasePipe } from '@angular/common';

@Component({
  selector: 'app-header-actions',
  templateUrl: './header-actions.component.html',
  styleUrls: ['./header-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, PopupModule, AccountMenuComponent, LangComponent, UpperCasePipe],
  host: {
    '(keydown)': 'keydown($event)',
    '(document:click)': 'documentClick($event)',
  },
})
export class HeaderActionsComponent implements OnInit {
  translate = inject(TranslateService);
  private helpService = inject(HelpService);
  private router = inject(Router);

  public CONSTANTS = CONSTANTS;
  public currentLang!: any;

  public anchorAlign: Align = { horizontal: 'right', vertical: 'bottom' };
  public popupAlign: Align = { horizontal: 'right', vertical: 'top' };

  public toggleText = 'Show';
  public show = false;
  public showAccount = false;

  public readonly anchor = viewChild('anchor', { read: ElementRef });
  public readonly popup = viewChild('popup', { read: ElementRef });

  public readonly anchorAccount = viewChild('anchorAccount', { read: ElementRef });
  public readonly popupAccount = viewChild('popupAccount', { read: ElementRef });

  public keydown(event: any): void {
    if (event.keyCode === 27) {
      this.toggle(false);
      this.toggleAccount(false);
    }
  }

  public documentClick(event: any): void {
    if (!this.contains(event.target)) {
      this.toggle(false);
      this.toggleAccount(false);
    }
  }

  public toggle(show?: boolean): void {
    this.show = show !== undefined ? show : !this.show;
    this.toggleText = this.show ? 'Hide' : 'Show';
    if (this.show == true) {
      this.showAccount = false;
    }
  }

  public toggleAccount(showAccount?: boolean): void {
    this.showAccount = showAccount !== undefined ? showAccount : !this.showAccount;
    this.toggleText = this.show ? 'Hide' : 'Show';
    if (this.showAccount == true) {
      this.show = false;
    }
  }

  private contains(target: any): boolean {
    return (
      (this.anchor()?.nativeElement.contains(target) ?? false) ||
      (this.popup()?.nativeElement.contains(target) ?? false) ||
      (this.anchorAccount()?.nativeElement.contains(target) ?? false) ||
      (this.popupAccount()?.nativeElement.contains(target) ?? false)
    );
  }

  public ngOnInit(): void {
    this.currentLang = localStorage.getItem('currentLanguage');
    this.currentLang = this.translate.currentLang;
  }

  public onHelp() {
    this.helpService.openHelp(CONSTANTS.help.confluenceOnline);
    /*let route = this.router.url.substring(1);
    var re = /\/\d+$/; // lomítko a čísla na konci řetězce
    this.helpService.openHelp(
      CONSTANTS.help.topicUrl + route.replace(re, '')
    );*/
  }
}
